import script from "./StarRating.vue?vue&type=script&setup=true&lang=ts"
export * from "./StarRating.vue?vue&type=script&setup=true&lang=ts"

import "./StarRating.vue?vue&type=style&index=0&id=366290fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-366290fc"]])

export default __exports__